import { Component } from '@angular/core';
import {FormInputComponent} from "../../utils/form-input/form-input.component";
import {MdbButtonComponent} from "../../utils/mdb-button/mdb-button.component";
import {AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {AuthWrapperComponent} from "../auth-wrapper/auth-wrapper.component";
import {AuthService} from "../../../services/auth/auth.service";
import {CustomNotificationService} from "../../../services/utils/custom-notification.service";
import {Router, RouterLink} from "@angular/router";
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-password-forgotten',
    imports: [
        FormInputComponent,
        MdbButtonComponent,
        ReactiveFormsModule,
        TranslateModule,
        AuthWrapperComponent,
        RouterLink
    ],
    templateUrl: './password-forgotten.component.html',
    styleUrl: './password-forgotten.component.scss'
})
export class PasswordForgottenComponent {
  loading: boolean = false
  formGroup: FormGroup = this.formBuilder.group({
    email: [null, [Validators.required, Validators.email]]
  })

  constructor(private formBuilder: FormBuilder,
              private authService: AuthService,
              private notificationService: CustomNotificationService,
              private router: Router) {
  }

  getFormControl(name: string): AbstractControl | null {
    return this.formGroup.get(name)
  }

  submit() {
    this.formGroup.markAllAsTouched()

    if(this.formGroup.invalid)
      return

    this.loading = true
  }

  protected readonly environment = environment;
}
